import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetManagementService {

  assetId: string;

  constructor(private http: HttpClient) { }

  getAssetDetailCount(customer_id): Observable<any> {
    const body = {
      customer_id: customer_id
    }
    return this.http.post<any>(`${environment.baseUrl}assetDetailCount`, body);
  }

  getAssetDetailLimit(customer_id, defaultLimit: number, intPage: number): Observable<any> {
    const body = {
      customer_id: customer_id,
      defaultLimit: defaultLimit,
      intPage: intPage
    }
    return this.http.post<any>(`${environment.baseUrl}getAssetDetailsWithLimit`, body);
  }

  getAssetId(){
    return this.assetId;
  }
  setAssetId(assetId){
    this.assetId = assetId;
  }

  getKeyCodeValues(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getKeyCodeValues`);
  }

  getOilTypeAssetValues(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getOilTypeAssetValues`);
  }

  getPurchaseGroups(customer_key): Observable<any> {
    const body = {
      customer_key: customer_key
    }
    return this.http.post<any>(`${environment.baseUrl}getPurchaseGroups`, body);
  }

  getBodyStyleConfigurations(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getBodyStyleConfigurations`);
  }

  getListEngineManufacturers(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getListEngineManufacturers`);
  }

  getSeverityOfServices(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getSeverityOfServices`);
  }

  getListEngineSizes(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getListEngineSizes`);
  }

  getState(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getState`);
  }

  getLeasingCompany(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getLeasingCompany`);
  }

  getAssetTypeGroups(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getAssetTypeGroups`);
  }

  getAssetMakes(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getAssetMakes`);
  }

  updateAssetDetails(assetDetails): Observable<any> {
    return this.http.post(`${environment.baseUrl}updateAssetDetails`, assetDetails);
  }

  getAssetDetailsByAssetId(assetId): Observable<any> {
    return this.http.post(`${environment.baseUrl}getAssetDetailsByAssetId`, assetId);
  }

  getAssetPMProgram(assetId): Observable<any> {
    return this.http.post(`${environment.baseUrl}getDueOverDueAndCurrentInspections`, assetId);
  }

  getScheduledAndPlannedInspections(assetId): Observable<any> {
    return this.http.post(`${environment.baseUrl}getScheduledAndPlannedInspections`, assetId);
  }
  
  getDriversByAsset(assetId): Observable<any> {
    return this.http.post(`${environment.baseUrl}getDriversByAsset`,assetId);
  }
  
  getPMDuesAssetDetail(assetId): Observable<any> {
    return this.http.get(`${environment.baseUrl}getPMDuesAssetDetail/${assetId}`);
  }

  saveDriverInfo(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}addDriversByAsset`,data);
  }

  updateAssetInfoByAssetId(assetDetails): Observable<any> {
    return this.http.post(`${environment.baseUrl}updateAssetInfoByAssetId`, assetDetails);
  }

  getExternalAssetDetails(ExternalAssetId): Observable<any> {
    let data = {
      "customerKey": sessionStorage.getItem('fleetCustomerId'),
      "externalAsset": ExternalAssetId
    }
    return this.http.post(`${environment.baseUrl}getExternalAssetDetails`, data);
  }
}
